class K2GroupFacilityAuthorization
  @restart_video: () ->
    $('#id-image').hide()
    $('#person-image').hide()
    $('#video-stream').show()
    $('#video-stream-window').show()
    $('#video-stream-window').css({height: '100%', left: '0', padding: '10px', position: 'fixed', top: '0', width: '100%', zIndex: '11'})
    $('#new_access_code_log').hide()
    $('#capture-button').show()

  @start_capture: () ->
    $('#video-stream').hide()
    $('#video-stream-window').hide()

    if $('#confirm-image').length == 0
      $('#confirm-image').hide()

    $('#capture-button').hide()
    if $('#overlay').length == 0
      $('#page').after('<div id="overlay"></div><div id="overlay-contents"><span class="instruction">Please wait...</span></div>')

  @stop_video: () ->
    $('#video-stream').attr('src', '/video_timed_out.html')

  @ready: () ->
    $('.capture_form').bind "ajax:beforeSend", (evt, xhr, settings) ->
      K2GroupFacilityAuthorization.start_capture()
    video_stream_timeout = setTimeout(K2GroupFacilityAuthorization.stop_video, 300000)

$(document).ready ->
  body = $('body')
  if body.data('controller') == 'cards' && body.data('action') == "group_facility_authorization"
    K2GroupFacilityAuthorization.ready()

module.exports = K2GroupFacilityAuthorization
